    window.ContentBlock__Accordion = function (accordionDom) {
        this.accordionDom = accordionDom;

        const classes = {
            UTILITY: {
                OPEN_PANEL: "cb-accordion-panel--open",
                CLOSE_PANEL: "cb-accordion-panel--close",
                OPEN_ARROW: "cb-accordion-arrow--open",
                CLOSE_ARROW: "cb-accordion-arrow--close",
                IS_OPEN: "is-open"
            },
            DOM: {
                WRAPPER: ".cb-accordion",
                TRIGGER: ".cb-accordion-trigger",
                PANEL: ".cb-accordion-panel",
                ARROW: ".cb-accordion-arrow"
            }
        }
        
        this.openedAccordionTrigger = undefined,

            this.createclassLists = function () {
                this.classLists = {};

                const keys = Object.keys(classes.UTILITY);

                for (const key of keys) {
                    this.classLists[key] = classes.UTILITY[key].split(" ");
                }
            }

        this.isContentInViewport = function (trigger, panel) {
            return (window.innerHeight > panel.getBoundingClientRect().bottom) && (trigger.getBoundingClientRect().top > 0);
        }

        this.scrollToTrigger = function (trigger, panel) {
            if (window.innerWidth < 640) {

                setTimeout(() => {
                    if (!this.isContentInViewport(trigger, panel)) {
                        trigger.scrollIntoView({
                            behavior: "smooth",
                            block: "start"
                        });
                    }
                }, 300);
            }
        }

        this.toggleAccordion = function (accordion, trigger) {
            let currentItem = {};
            let previousOpenItem = {};

            currentItem.arrow = trigger.querySelector(classes.DOM.ARROW);
            currentItem.panel = document.getElementById(trigger.getAttribute("aria-controls"));

            if (this.openedAccordionTrigger === trigger) {
                // If the clicked item was open then previousOpenItem is the same
                previousOpenItem = currentItem;

                // clear the stored openTrigger
                this.openedAccordionTrigger = undefined;
            } else {
                // Find the open element
                previousOpenItem.arrow = accordion.getElementsByClassName(classes.UTILITY.OPEN_ARROW)[0];
                previousOpenItem.panel = accordion.getElementsByClassName(classes.UTILITY.OPEN_PANEL)[0];

                // Set the items open of clicked element
                currentItem.arrow.classList.remove(...this.classLists.CLOSE_ARROW);
                currentItem.arrow.classList.add(...this.classLists.OPEN_ARROW);

                currentItem.panel.classList.remove(...this.classLists.CLOSE_PANEL);
                currentItem.panel.classList.add(...this.classLists.OPEN_PANEL);

                // store the clicked trigger item
                this.openedAccordionTrigger = trigger;
            }

            // Close the open element if there's any
            if (previousOpenItem.arrow && previousOpenItem.panel) {
                previousOpenItem.arrow.classList.remove(...this.classLists.OPEN_ARROW)
                previousOpenItem.arrow.classList.add(...this.classLists.CLOSE_ARROW)
                previousOpenItem.panel.classList.remove(...this.classLists.OPEN_PANEL)
                previousOpenItem.panel.classList.add(...this.classLists.CLOSE_PANEL)
            };

            this.scrollToTrigger(trigger, currentItem.panel);
        }

        this.setupEventListeners = function(accordion) {
            var triggers = Array.prototype.slice.call(accordion.querySelectorAll(classes.DOM.TRIGGER));

            if (triggers) {
                triggers.forEach(function (trigger) {
                    trigger.addEventListener('click', function (event) {
                        event.preventDefault();

                        this.toggleAccordion(accordion, trigger);
                    }.bind(this));
                }.bind(this));
            }
        },

        this.init = function () {
            this.createclassLists();

            if (this.accordionDom) {
                this.setupEventListeners(this.accordionDom);
            }
        }
    };